import { SharedTab, BaseTabProps } from '../index';
import { RequirementsCard } from './RequirementsCard';

interface FlatFileProps
  extends BaseTabProps<{
    formflatFileIntegration: string;
    externalCode: string;
  }> {}

const FlatFile = ({
  form,
  initialValues,
  fields,
  renderInput,
  className,
}: FlatFileProps) => {
  return (
    <SharedTab
      form={form}
      initialValues={initialValues}
      fields={fields}
      renderInput={renderInput}
      className={className}
    >
      <RequirementsCard />
    </SharedTab>
  );
};

export default FlatFile;
